export default __webpack_public_path__ + "static/media/way-2.0d7d501c.png";